
<div class="header-toolbar">
  <h1>
    Utilisateurs clients <span>Supprimés</span>

    <span class="tag" *ngIf="filter.search">
      <span class="text">Recherche: {{ filter.search }}</span>
      <t-icon name="close" title="Supprimer ce filtre" (click)="clearSearch()"></t-icon>
    </span>
  </h1>
</div>

<!-- Toolbar -->
<div class="main btn-toolbar">

  <div class="btn-group">    
    <div class="content">
      
      <button class="btn" (click)="applyFilter()">
        <t-icon name="search"></t-icon>
        <span class="text">Filtrer</span>
      </button>

    </div>
  </div>

</div>
<!-- /Toolbar -->

<table>

  <thead>
    <tr>
      <th>Nom d'utilisateur</th>
      <th>Prènom</th>
      <th>Nom</th>
      <th>Date d'ajout</th>
      <th>Fuseau horaire</th>
      <th>Role</th>
      <th>Compte client</th>
      <th style="width: 100px;"></th>
    </tr>
  </thead>

  <tbody *ngIf="users && users.length > 0">
    <tr *ngFor="let user of users" (click)="showCLUser(user, $event)">
      <td name="Nom d'utilisateur">{{ user.username }}</td>
      <td name="Prènom">{{ user.firstname }}</td>
      <td name="Nom">{{ user.lastname }}</td>
      <td name="Date d'ajout">{{ user.createdAt | tzdate:'short' }}</td>
      <td name="Fuseau horaire">{{ user.timezone }}</td>
      <td name="Role">{{ user.role | cluserrole }}</td>
      <td name="Compte client">{{ user.account.name }}</td>
      <td style="width: 100px;" class="actions">
        <a class="action-btn" title="Restaurer" (click)="restore(user)">
          <t-icon name="settings_backup_restore"></t-icon>
        </a>
      </td>
    </tr>
  </tbody>

  <tbody *ngIf="!users || users.length == 0">
    <tr>
      <td class="text-center" colspan="8">
        <ng-container *ngIf="users && users.length == 0">
          Aucun utilisateur n'a été trouvé
        </ng-container>
        <ng-container *ngIf="!users">
          Chargement...
        </ng-container>
      </td>
    </tr>
  </tbody>

</table>

<div class="pagination" *ngIf="users">
  <button class="btn btn-gray" (click)="fetchMore()" *ngIf="users.length < usersCount">
    <t-icon name="arrow_downward"></t-icon>
    <span class="text">Afficher plus</span>
  </button>
  <div class="page-number">
    {{ users.length }} / {{ usersCount }}
  </div>
</div>